import { ColorProps, SizeProps, VariationProps } from '@/types/Product';

// Opção que vem pré-selecionada ao abrir o produto — a primeira COM stock,
// não simplesmente a primeira da lista (senão, com a primeira cor esgotada,
// o cliente via "Esgotado" mesmo havendo outras cores disponíveis). Sem
// nenhuma com stock, cai para a primeira (o produto aparece esgotado, ou é
// pré-venda e pode ser comprado na mesma).
//
// Usado tanto na pré-seleção da página como no preço dos dados
// estruturados, para o Google ver o mesmo preço que o cliente vê.

export function pickDefaultVariation(
  variations: VariationProps[],
): VariationProps | null {
  return variations.find((v) => v.stock > 0) ?? variations[0] ?? null;
}

export function pickDefaultColorSize(
  colors: ColorProps[],
): { color: ColorProps; size: SizeProps } | null {
  for (const color of colors) {
    const size = color.sizes.find((s) => s.stock > 0);
    if (size) return { color, size };
  }

  const firstWithSizes = colors.find((c) => c.sizes.length > 0);
  return firstWithSizes
    ? { color: firstWithSizes, size: firstWithSizes.sizes[0] }
    : null;
}
